import React from "react";
import { DiJavascript1, DiReact, DiNodejs, DiMongodb, DiGit, DiHtml5, DiCss3 } from "react-icons/di";
import {
  SiTypescript, SiNextdotjs, SiRedux, SiTailwindcss,
  SiPostgresql, SiRedis, SiGraphql, SiDocker, SiExpress,
  SiMysql, SiKubernetes, SiNginx, SiJenkins, SiGithubactions,
  SiMicrosoftazure,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";

const CATEGORIES = [
  {
    label: "Languages",
    techs: [
      { icon: <DiJavascript1 />, name: "JavaScript", color: "#F7DF1E" },
      { icon: <SiTypescript />,  name: "TypeScript",  color: "#3178C6" },
      { icon: <DiHtml5 />,       name: "HTML5",       color: "#E34F26" },
      { icon: <DiCss3 />,        name: "CSS3",        color: "#1572B6" },
    ],
  },
  {
    label: "Frontend",
    techs: [
      { icon: <DiReact />,       name: "React.js",    color: "#61DAFB" },
      { icon: <SiNextdotjs />,   name: "Next.js",     color: "#ffffff" },
      { icon: <SiRedux />,       name: "Redux",       color: "#764ABC" },
      { icon: <SiTailwindcss />, name: "Tailwind CSS",color: "#38BDF8" },
    ],
  },
  {
    label: "Backend",
    techs: [
      { icon: <DiNodejs />,      name: "Node.js",     color: "#68A063" },
      { icon: <SiExpress />,     name: "Express.js",  color: "#ffffff" },
      { icon: <SiGraphql />,     name: "GraphQL",     color: "#E10098" },
    ],
  },
  {
    label: "Database & Cache",
    techs: [
      { icon: <SiPostgresql />,  name: "PostgreSQL",  color: "#336791" },
      { icon: <DiMongodb />,     name: "MongoDB",     color: "#4DB33D" },
      { icon: <SiMysql />,       name: "MySQL",       color: "#4479A1" },
      { icon: <SiRedis />,       name: "Redis",       color: "#DC382D" },
    ],
  },
  {
    label: "Cloud & DevOps",
    techs: [
      { icon: <FaAws />,              name: "AWS",            color: "#FF9900" },
      { icon: <SiDocker />,           name: "Docker",         color: "#2496ED" },
      { icon: <SiKubernetes />,       name: "Kubernetes",     color: "#326CE5" },
      { icon: <SiGithubactions />,    name: "GitHub Actions", color: "#2088FF" },
      { icon: <SiJenkins />,          name: "Jenkins",        color: "#D33833" },
      { icon: <SiMicrosoftazure />,   name: "Azure DevOps",   color: "#0078D4" },
      { icon: <SiNginx />,            name: "NGINX",          color: "#009639" },
    ],
  },
  {
    label: "Version Control",
    techs: [
      { icon: <DiGit />,         name: "Git",         color: "#F05032" },
    ],
  },
];

function Techstack() {
  return (
    <div className="techstack-categories">
      {CATEGORIES.map(({ label, techs }) => (
        <div key={label} className="techstack-category">
          <span className="techstack-category-label">{label}</span>
          <div className="techstack-icons-row">
            {techs.map(({ icon, name, color }) => (
              <div key={name} className="techstack-icon-item" title={name}>
                <div className="techstack-icon" style={{ "--icon-color": color }}>
                  {icon}
                </div>
                <span className="techstack-icon-name">{name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Techstack;
